import React from "react";
import { Helmet } from "react-helmet-async";
import { HomePage } from "./pages/Home";
import { AboutPage } from "./pages/About";
import { ContactPage } from "./pages/Contact";
import { ServicesPage } from "./pages/Services";
import { NoPage404 } from "./pages/Nopage404";

export const Home = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    return (
        <>
        <Helmet>
            <title>Izrada Web Sajta Cena | Profesionalna izrada web sajtova</title>
            <meta name="description" content="Izuzetno povoljna izrada web sajtova cena transparentna i povoljna za sve. Pokrenite vaš online biznis mi ćemo vam pomoći." />
        </Helmet>
        <HomePage />
        </>
    );
}

export const About = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    return (
        <>
        <Helmet>
            <title>O nama | Izrada Web Sajta Cena</title>
            <meta name="description" content="Saznaj više o nama." />
        </Helmet>
        <AboutPage />
        </>
    );
}

export const Contact = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    return (
        <>
        <Helmet>
            <title>Kontakt | Izrada Web Sajta Cena</title>
            <meta name="description" content="Zakaži besplatnu procenu." />
        </Helmet>
        <ContactPage />
        </>
    );
}

export const Services = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    return (
        <>
        <Helmet>
            <title>Servisi | Izrada Web Sajta Cena</title>
            <meta name="description" content="Zakaži besplatnu procenu." />
        </Helmet>
        <ServicesPage />
        </>
    );
}

export const NoPage = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
    return (
        <>
        <Helmet>
            <title>404 greška | Izrada Web Sajta Cena</title>
            <meta name="description" content="404 greška - nepostojeća strana." />
        </Helmet>
        <NoPage404 />
        </>
    );
}